import {
  Card,
  CardContent,
  Typography,
  makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
  },
  value: {
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
}));

interface MetricsSummaryCardProps {
  totalDeployments: number;
}

export const MetricsSummaryCard = ({
  totalDeployments,
}: MetricsSummaryCardProps) => {
  const classes = useStyles();

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent className={classes.content}>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          Total de Deployments
        </Typography>
        <Typography variant="h2" className={classes.value}>
          {totalDeployments}
        </Typography>
      </CardContent>
    </Card>
  );
};
